import { ColorValue, StyleProp, StyleSheet, ViewStyle } from 'react-native';
import { Colors } from '../../themes/colors';
import { useThemeMode } from '../../themes/useThemeMode';
import { Button } from '../crop-circle/Button';

type AssetActionButtonProps = {
  onAddNew: () => void;
  buttonContainerStyle: StyleProp<ViewStyle>;
  buttonStyle: StyleProp<ViewStyle>;
  text: string;
  iconSize?: number;
  backgroundColor?: ColorValue | undefined;
  state?: 'default' | 'active' | 'warning' | 'outline';
};

export const AssetActionButton = (props: AssetActionButtonProps) => {
  useThemeMode();

  // Overriding `backgroundColor` replaces the FILL that `state` would have
  // picked, but `Button` still derives its label from `state`. With
  // `state="active"` that label is `textOnInverse` — the token paired with the
  // white-in-dark `surfaceInverse` fill, i.e. near-black. On the brand-orange
  // fill this button actually paints, that rendered a black label in dark mode
  // (it only looked right in light, where `textOnInverse` happens to be white).
  // A caller-supplied fill is a brand fill, so pair it with `textOnBrand`,
  // which is #FFFFFF in both modes.
  const textStyle = props.backgroundColor
    ? { color: Colors.role.textOnBrand }
    : undefined;

  return (
    <Button
      style={{
        ...styles.buttonContainer,
        ...(props.backgroundColor && {
          backgroundColor: props.backgroundColor,
        }),
      }}
      textStyle={textStyle}
      onPress={props.onAddNew}
      state={props.state}
    >
      {props.text}
    </Button>
  );
};

const styles = StyleSheet.create({
  buttonContainer: {
    flex: 1,
    height: 56,
    maxHeight: 56,
  },
});
